module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Wattwil-8c4252643a7d7722ab04d3a454ab8954.svg";